export default "__VITE_ASSET__BgYgGBZ1__ 1200w";